import styled from 'styled-components';

const FormGrid = styled.div`
  display: grid;
  grid-gap: 40px;
`;

export default FormGrid;
